<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="3"
      y="3"
      width="14"
      height="14"
      rx="0.9"
      stroke="#8D5185"
      stroke-width="2"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 34,
    },
    height: {
      type: Number,
      default: 34,
    },
  },
};
</script>

<style lang="scss" scoped></style>
